export enum ECourseFrequency {
	DAILY = "D",
	WEEKLY = "W",
}
